import { render, staticRenderFns } from "./PersonParentDetails.vue?vue&type=template&id=369d7920&"
import script from "./PersonParentDetails.vue?vue&type=script&lang=js&"
export * from "./PersonParentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports